import { services } from "@/mocks/home";

export default function ServicesSection() {
  return (
    <section id="services" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="text-center">
          <p className="font-label text-[36px] font-bold tracking-[0.15em] text-foreground-700 md:text-[40px]">
            OUR SERVICE
          </p>
          <h2 className="mt-3 font-heading text-4xl font-black leading-tight text-foreground-950 md:text-7xl">
            株式会社ナンバの事業
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:mt-14 md:gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-100/60 transition-colors hover:border-primary-300"
            >
              <div className="relative h-48 w-full overflow-hidden border-b border-background-200 bg-background-100 md:h-[13rem]">
                <img
                  src={service.image}
                  alt={`${service.title}のサービスイメージ`}
                  title={`ナンバ ${service.title}`}
                  className="h-full w-full object-cover object-top"
                />
              </div>

              <div className="p-6">
                <h3 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">
                  {service.title}
                </h3>
                <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}